import { gql } from 'apollo-boost'

const ADVANCED_PROBE_SESSION_MENUS = gql`
  query advancedProbeSessionMenus($sessionId: ID!, $page: Int, $pageSize: Int) {
    advancedProbeSessionMenus(
      advancedProbeSessionId: $sessionId
      page: $page
      pageSize: $pageSize
    ) {
      advancedProbeSessionMenus {
        menuId
        menuStatus
        clusterId
        probingJobStatus
        probingStatus
        probingJobScheduleDate
        probingJobCompletedDate
        probingDetectedChanges
        scrapingJobStatus
        scrapingStatus
        scrapingJobScheduleDate
        scrapingJobCompletedDate
        scrapingDetectedChanges
      }
      total
    }
  }
`

export default ADVANCED_PROBE_SESSION_MENUS
